import { render, staticRenderFns } from "./OrderGroupingAppointment.vue?vue&type=template&id=54f362e4&scoped=true&"
import script from "./OrderGroupingAppointment.vue?vue&type=script&lang=js&"
export * from "./OrderGroupingAppointment.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupingAppointment.vue?vue&type=style&index=0&id=54f362e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f362e4",
  null
  
)

export default component.exports